var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 46V41.5467C18 40.6455 18.2555 39.8174 18.7665 39.0625C19.2775 38.3075 19.9553 37.7307 20.8 37.3321C22.6083 36.5103 24.4458 35.8943 26.3125 35.484C28.1792 35.0736 30.075 34.8679 32 34.8669C33.925 34.8658 35.8208 35.0715 37.6875 35.484C39.5542 35.8964 41.3917 36.5125 43.2 37.3321C44.0458 37.7297 44.7242 38.3065 45.2352 39.0625C45.7462 39.8185 46.0012 40.6466 46 41.5467V46H18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9403 19.8688C35.5695 18.6229 33.9216 18 31.9966 18C30.0716 18 28.4237 18.6229 27.0528 19.8688C25.682 21.1146 24.9966 22.6123 24.9966 24.3618L24.9966 29.9283C24.9954 30.59 25.2503 31.153 25.7613 31.6174C26.2723 32.0818 26.8924 32.314 27.6216 32.314C28.0579 32.314 28.4733 32.2212 28.8676 32.0357C29.2619 31.8501 29.5757 31.5851 29.8091 31.2405C30.0401 31.5851 30.3533 31.8501 30.7488 32.0357C31.1443 32.2212 31.5603 32.314 31.9966 32.314C32.4329 32.314 32.8483 32.2212 33.2426 32.0357C33.6369 31.8501 33.9508 31.5851 34.1841 31.2405C34.4163 31.5851 34.7295 31.8501 35.1238 32.0357C35.5182 32.2212 35.9341 32.314 36.3716 32.314C37.0996 32.313 37.7191 32.0808 38.2301 31.6174C38.7411 31.1541 38.9966 30.591 38.9966 29.9283L38.9966 24.3618C38.9966 22.6123 38.3112 21.1146 36.9403 19.8688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.8e83b4075ab0ee317c9ae2506ea9a90d.svg";
export { ForwardRef as ReactComponent };